import { embeddingBadgeStyles } from '@blocksuite/affine-shared/services';
import { unsafeCSSVarV2 } from '@blocksuite/affine-shared/theme';
import { css } from 'lit';

export const styles = css`
  ${embeddingBadgeStyles}

  .affine-attachment-container {
    position: relative;
    border-radius: 8px;
    box-sizing: border-box;
    user-select: none;
    /* overflow stays visible so the embedding badge's details popover is not
       clipped; corner clipping is applied to the embed content instead. */
    overflow: visible;
    border: 1px solid transparent;
    background: ${unsafeCSSVarV2('layer/background/primary')};

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      box-shadow: inset 0 0 0 1px ${unsafeCSSVarV2('layer/background/tertiary')};
      pointer-events: none;
      z-index: 1;
    }

    &.focused::after {
      box-shadow: inset 0 0 0 1px
        ${unsafeCSSVarV2('layer/insideBorder/primaryBorder')};
    }
  }

  .affine-attachment-container.comment-highlighted {
    outline: 2px solid ${unsafeCSSVarV2('block/comment/highlightUnderline')};
  }

  .affine-attachment-card {
    display: flex;
    gap: 12px;
    padding: 12px;
  }

  .affine-attachment-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex: 1 0 0;
    min-width: 0;
  }

  .truncate {
    align-self: stretch;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .affine-attachment-content-title {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    align-self: stretch;
  }

  .affine-attachment-content-title-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--streamlain-v2-text-primary);
    font-size: 16px;
  }

  .affine-attachment-content-title-text {
    color: var(--streamlain-v2-text-primary);
    font-family: var(--streamlain-font-family);
    font-size: var(--streamlain-font-sm);
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }

  .affine-attachment-content-description {
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: 8px;
  }

  .affine-attachment-content-info {
    color: var(--streamlain-v2-text-secondary);
    font-family: var(--streamlain-font-family);
    font-size: var(--streamlain-font-xs);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .affine-attachment-content-button {
    display: flex;
    height: 20px;
    align-items: center;
    align-self: stretch;
    gap: 4px;
    white-space: nowrap;
    padding: 0 4px;
    color: ${unsafeCSSVarV2('button/primary')};
    font-family: var(--streamlain-font-family);
    font-size: var(--streamlain-font-xs);
    font-style: normal;
    font-weight: 500;
    text-transform: capitalize;
    line-height: 20px;

    svg {
      font-size: 16px;
    }
  }

  .affine-attachment-banner {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .affine-attachment-card.loading {
    .affine-attachment-content-title-text {
      color: ${unsafeCSSVarV2('text/placeholder')};
    }
  }

  .affine-attachment-card.error {
    .affine-attachment-content-title-icon {
      color: ${unsafeCSSVarV2('status/error')};
    }
  }

  .affine-attachment-card.local-storage-unavailable {
    .affine-attachment-content-info {
      display: -webkit-box;
      overflow: hidden;
      white-space: normal;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .affine-attachment-card.loading,
  .affine-attachment-card.error {
    background: ${unsafeCSSVarV2('layer/background/secondary')};
  }

  .affine-attachment-card.cubeThick {
    flex-direction: column-reverse;

    .affine-attachment-content {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
    }

    .affine-attachment-banner {
      justify-content: space-between;
    }
  }

  .affine-attachment-embed-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* Clip the embedded content (e.g. iframe) to the rounded card corners now
       that the outer container no longer clips. */
    border-radius: 8px;
    overflow: hidden;
  }

  .affine-attachment-embed-status {
    position: absolute;
    left: 14px;
    bottom: 64px;
  }

  .affine-attachment-embed-event-mask {
    position: absolute;
    inset: 0;
  }

  .affine-attachment-progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${unsafeCSSVarV2('layer/background/tertiary')};
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }

  .affine-attachment-progress-bar-fill {
    height: 100%;
    background: ${unsafeCSSVarV2('button/primary')};
    transition: width 0.2s ease;
    border-radius: 0 0 8px 8px;
  }
`;
